import React from 'react';

interface ILayoutLogin {
    children?: React.ReactNode
}

const LayoutLogin = ({
    children
}: ILayoutLogin) => {
    return (
        <div className='flex justify-center items-center min-w-full min-h-screen'>
            <div className='min-h-full p-6'>
                {children}
            </div>
        </div >
    )
}

export default LayoutLogin;